const homeAnim = {
  init() {
    document.addEventListener("DOMContentLoaded", () => {
      

      /* GSAP ANIMATIONS */

      //Smooth content

      ScrollSmoother.create({
        wrapper: "#smooth-container",
        content: "#smooth-content",
        smooth: 1,
        effects: false,
      });

      // LIENS ANCRES 

      // après avoir initialisé ScrollSmoother 
if (window.location.hash) {
  const id = window.location.hash.slice(1);
  const target = document.getElementById(id);
  if (target) {
    const smoother = ScrollSmoother.get();
    if (smoother) {
      smoother.scrollTo(target, true, "top top");
    } else {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }
}

      let heroBtn = document.querySelector(".hero-btn");
      heroBtn.addEventListener("click", (e) => {
        e.preventDefault();
        let target = document.querySelector(heroBtn.getAttribute("href"));
        ScrollSmoother.get().scrollTo(target, true, "center center");
      });

      // Sélectionne tous les liens dans le menu et le footer
      const checkSmoother = setInterval(() => {
        if (typeof ScrollSmoother !== "undefined" && ScrollSmoother.get()) {
          clearInterval(checkSmoother);

          // Sélectionne tous les liens dans le menu et le footer
          const menuLinks = document.querySelectorAll(
            '.topmenu-container a[href*="#"], footer a[href*="#"]',
          );
          menuLinks.forEach((link) => {
            link.addEventListener("click", function (e) {
              // only intercept links that point to an anchor on the *current* page
              const href = this.getAttribute("href");
              if (!href) return;

              // build a URL to compare pathnames even when href is relative
              const url = new URL(href, window.location.origin);
              if (url.pathname !== window.location.pathname) {
                // different page, allow normal navigation
                return;
              }

              e.preventDefault();

              // extract the anchor id and scroll to it
              const targetId = url.hash.replace("#", "");
              if (!targetId) return;

              const target = document.getElementById(targetId);
              if (!target) return;

              const smoother = ScrollSmoother.get();
              if (smoother) {
                smoother.scrollTo("#" + targetId, true, "top top");
              } else {
                target.scrollIntoView({ behavior: "smooth", block: "start" });
              }
            });
          });
        }
      }, 100); // Vérifie toutes les 100ms

    
      /* Ligne dégradée */

      let gradientLine = document.querySelector(".gradient-line");
      if (gradientLine) {
        ScrollTrigger.create({
          trigger: ".gradient-line",
          start: "top bottom-=20px",
          endTrigger: "footer",
          end: "bottom+=100vh bottom",
          pin: true,
          pinType: "fixed",
          markers: false,
          pinReparent: true,
          pinSpacing: false,
        });

        // Ajoute un écouteur pour le redimensionnement
        window.addEventListener("resize", () => {
          ScrollTrigger.refresh();
        });
      }

      //Hero
      gsap.to(".home-hero .plus-sign", {
        scale: "1",
        marginTop: "0px",
        delay: 0.2,
        duration: 0.4,
      });

      //Section Projets
      let projets = document.querySelectorAll(".project-card");
      projets.forEach((projet) => {
        const title = projet.querySelector(".project-title span.title");
        const plussign = projet.querySelector(".project-title .plus-sign");

        // Crée une timeline pour chaque projet
        let tl = gsap.timeline({ paused: true });

        tl.to(title, {
          opacity: 0,
          duration: 0.3,
        }).to(
          plussign,
          {
            left: "50%",
            top: "50%",
            duration: 0.3,
          },
          "<",
        ); // "<" pour lancer en même temps que l'animation précédente

        projet.addEventListener("mouseenter", () => {
          tl.play();
        });

        projet.addEventListener("mouseleave", () => {
          tl.reverse();
        });
      });

      //Section contact
      /* Animation du + */
      gsap.to("#contact .plus-sign", {
        scrollTrigger: {
          trigger: "#contact .plus-sign",
          start: "top 80%",
          toggleActions: "play none none reverse",
        },
        scale: "1",
        marginTop: "0px",
        duration: 0.4,
      });

      // Scroll to top button
      const scrollToTopBtn = document.getElementById("scroll-to-top");
      if (scrollToTopBtn) {
        window.addEventListener("scroll", () => {
          if (window.scrollY > 300) {
            scrollToTopBtn.classList.add("visible");
          } else {
            scrollToTopBtn.classList.remove("visible");
          }
        });

        scrollToTopBtn.addEventListener("click", () => {
          ScrollSmoother.get().scrollTo(0, true);
        });
      }
    });
  },
};

export default homeAnim;
